import { v4 as uuidv4 } from 'uuid';
import { CreateVariant } from '../../../MasterTabsProvider';
import { ExportDocumentToolsCreatePluginView } from '../view/ExportDocumentToolsCreatePluginView';
import ExportDocumentToolsGridPluginSettings from '../ExportDocumentToolsGridPluginSettings';

export const ExportDocumentToolsCreateTab = (variant?: CreateVariant, idGlobal?: string, data?, parentCallback?: () => void): ITab => {
    const checkCopyTabVariantId = variant === "edit" && idGlobal !== undefined ? idGlobal : uuidv4();
    return {
        id: checkCopyTabVariantId,
        title: 'Формат экспорта DBF',
        plugin: 'export_document_tools_create_plugin',
        view: {
            content: <ExportDocumentToolsCreatePluginView
                variant={variant ?? 'create'}
                idGlobal={idGlobal}
                createdCallback={() => parentCallback?.()}
                permission={ExportDocumentToolsGridPluginSettings.permission as IPermission}
            />
        }
    }
}